const flagMap = {
  global: 'g',
  ignoreCase: 'i',
  multiline: 'm',
  dotAll: 's',
  sticky: 'y',
  unicode: 'u',
} as const

export function cloneRegexp(regexp: RegExp, options: Partial<Record<keyof typeof flagMap, boolean>> = {}) {
  const flags = []

  let key: keyof typeof flagMap
  for (key in flagMap) {
    if (options[key] || regexp[key]) {
      flags.push(flagMap[key])
    }
  }

  const clonedRegexp = new RegExp(regexp.source, flags.join(''))

  clonedRegexp.lastIndex = regexp.lastIndex

  return clonedRegexp
}
